import { cx } from './shared';

export interface ProgressProps {
  label: string;
  value?: number;
  max?: number;
  valueLabel?: string;
  showValue?: boolean;
  className?: string;
}

export function Progress({
  label,
  value,
  max = 100,
  valueLabel,
  showValue = true,
  className,
}: ProgressProps) {
  const isDeterminate = value != null;
  const boundedMax = max > 0 ? max : 100;
  const boundedValue = isDeterminate ? Math.min(Math.max(value, 0), boundedMax) : undefined;
  const percentage = boundedValue == null ? undefined : (boundedValue / boundedMax) * 100;
  const visibleValue =
    valueLabel ?? (percentage == null ? 'In progress' : `${Math.round(percentage)}%`);

  return (
    <div className={cx('grid gap-2', className)}>
      <div className="flex items-baseline justify-between gap-inline-control-gap text-control">
        <span className="font-semibold text-ink-strong">{label}</span>
        {showValue ? <span className="so-data-text text-ink-muted">{visibleValue}</span> : null}
      </div>
      <div
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={isDeterminate ? boundedMax : undefined}
        aria-valuenow={boundedValue}
        aria-valuetext={visibleValue}
        className="h-2 overflow-hidden rounded-pill bg-surface-recessed shadow-inset"
      >
        {isDeterminate ? (
          <div
            className="so-interactive h-full rounded-pill bg-accent"
            style={{ width: `${percentage}%` }}
          />
        ) : (
          <div className="so-progress-indeterminate h-full w-1/3 rounded-pill bg-status-loading" />
        )}
      </div>
    </div>
  );
}
